import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { Steps } from '../edit-template.dto';
import { StepEnum, stepsTranslation } from '../eform-steps.dto';
import { EformStepsService } from './eform-steps.service';
import { of, delay, take, Subscription, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-eform-steps',
  templateUrl: './eform-steps.component.html',
  styleUrl: './eform-steps.component.scss'
})
export class EformStepsComponent implements OnInit, OnDestroy {
  @Input() form!: FormGroup;
  @Input() get hideEditOption(): boolean {
    return this.hideEditIcon;
  }
  set hideEditOption(value: boolean) {
    this.hideEditIcon = value || false;
  }
  @Input() get disableTabSwitch(): boolean {
    return this.disableTabs;
  }
  set disableTabSwitch(value: boolean) {
    this.disableTabs = value || false;
  }
  public hideEditIcon:boolean = false;
  public disableTabs:boolean = false;
  public currentStep:string = StepEnum.ActiveRoleField;
  
  protected stepsTranslation = stepsTranslation;

  private timeOutSubscription: Subscription;
  private destroy$ = new Subject<void>();
  
  constructor(
    private eformStepsService: EformStepsService
  ) { }

  ngOnInit(): void {
    this.eformStepsService.activeStep$.pipe(takeUntil(this.destroy$)).subscribe(step => {
      this.currentStep = step;
    });
  }  

  onStepChange(step: Steps) {
    if(!this.disableTabs){
      this.eformStepsService.setActiveStep(step.key);
    }
  }

  editStepHeading(event: Event, field: string, index: number, save: boolean = false) {
    event.stopPropagation();
    const formArray = this.eform_steps.controls;
    // Toggle edit mode for heading or subheading
    if (field === 'heading') {
      formArray[index].patchValue({editingHeading:!save});
    } else if (field === 'subheading') {
      formArray[index].patchValue({editingSubheading:!save});
    }
    if(!save){
      this.timeOutSubscription = of(null).pipe(delay(200),take(1)).subscribe(() => {
          document.getElementById(`${index}-${field}`).focus()
      })
    }
  }

  /**
     * Get convert to eform form controls
     */
  get convert_to_eform_settings() {
    return this.form?.get('convert_to_eform_settings') as FormGroup;
  }

  /**
    * Get eform steps array as FormArray
    */
  get eform_steps() {
    return this.convert_to_eform_settings?.controls?.["eform_steps"] as FormArray;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
